export const remJS = () => {
  // 设计图 屏幕宽度
  const designDrawingWidth = 1920
  const docEle = document.documentElement
  const fontSize = docEle.clientWidth * 16 / designDrawingWidth;
  docEle.style.fontSize = fontSize > 16 ? `${fontSize.toFixed(0)}px` : 16;
}

export const startRem = () => {
  window.onresize = remJS
  remJS()
}

export const clearRem = () => {
  window.onresize = null
  const htmlDom = document.documentElement
  htmlDom.style.fontSize = `${16}px`
}
